module.exports = __webpack_public_path__ + "static/media/Miscellaneous-2x.03c771d6.jpeg";